const isUrlValid = (urlString: string) => {
  // try {
  //   new URL(urlString);
  //   return true;
  // } catch (err) {
  //   return false;
  // }
  const urlRegex =
    /^(?:(?:https?):\/\/)?(?:[\w-]+\.)+[a-z]{2,}(?:\/[\w-]*)*(?:\?.*)?$/i;
  return urlRegex.test(urlString);
};

export { isUrlValid };
